
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { CircleDollarSign, Clock, CheckCircle, XCircle } from 'lucide-react';
import RecentOrdersTable from './RecentOrdersTable';

interface StatusCount {
  status: string;
  count: number;
}

interface RecentOrder {
  order_id: string;
  user_email: string;
  amount: number;
  status: string;
  created_at: string;
  product_name: string;
}

interface OrdersSummaryProps {
  totalCount: number;
  statusCounts: StatusCount[];
  recentOrders: RecentOrder[];
}

const OrdersSummary = ({ totalCount, statusCounts, recentOrders }: OrdersSummaryProps) => {
  const getStatusCount = (status: string): number => {
    const found = statusCounts.find(item => item.status === status);
    return found ? found.count : 0;
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
        <Card>
          <CardContent className="p-4 flex items-center gap-4">
            <div className="p-3 rounded-full bg-blue-100 text-blue-600">
              <CircleDollarSign className="h-6 w-6" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Orders</p>
              <h3 className="text-2xl font-bold">{totalCount}</h3>
            </div>
          </CardContent>
        </Card>
        
        <Card>
          <CardContent className="p-4 flex items-center gap-4">
            <div className="p-3 rounded-full bg-green-100 text-green-600">
              <CheckCircle className="h-6 w-6" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Paid</p>
              <h3 className="text-2xl font-bold">{getStatusCount('PAID')}</h3>
            </div>
          </CardContent>
        </Card>
        
        <Card>
          <CardContent className="p-4 flex items-center gap-4">
            <div className="p-3 rounded-full bg-yellow-100 text-yellow-600">
              <Clock className="h-6 w-6" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Pending</p>
              <h3 className="text-2xl font-bold">{getStatusCount('PENDING')}</h3>
            </div>
          </CardContent>
        </Card>
        
        <Card>
          <CardContent className="p-4 flex items-center gap-4">
            <div className="p-3 rounded-full bg-red-100 text-red-600">
              <XCircle className="h-6 w-6" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Failed</p>
              <h3 className="text-2xl font-bold">{getStatusCount('FAILED')}</h3>
            </div>
          </CardContent>
        </Card>
      </div>
      
      <div>
        <h3 className="text-lg font-medium mb-4">Recent Orders</h3>
        <RecentOrdersTable orders={recentOrders} />
      </div>
    </div>
  );
};

export default OrdersSummary;
